var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('operator-table',{attrs:{"orders":_vm.orders,"pagination":_vm.pagination,"headers":_vm.headers},on:{"getData":_vm.getDataWalking,"doAction":_vm.doAction}})}
var staticRenderFns = []

export { render, staticRenderFns }